/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});function n(e,r){const a=(e||"").split(".");let t=r;return a.forEach(i=>{t=t?t[i]:void 0}),t}function o(e){return e.length!==void 0}exports.getNestedValue=n;exports.isArray=o;
